<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="人群 id" prop="audienceId">
          <el-input v-model="dataForm.audienceId" placeholder="人群 id"></el-input>
      </el-form-item>
          <el-form-item label="人群归属的推广帐号 id" prop="accountId">
          <el-input v-model="dataForm.accountId" placeholder="人群归属的推广帐号 id"></el-input>
      </el-form-item>
          <el-form-item label="人群名称" prop="name">
          <el-input v-model="dataForm.name" placeholder="人群名称"></el-input>
      </el-form-item>
          <el-form-item label="广告主对人群在自己系统里的编码" prop="externalAudienceId">
          <el-input v-model="dataForm.externalAudienceId" placeholder="广告主对人群在自己系统里的编码"></el-input>
      </el-form-item>
          <el-form-item label="人群描述" prop="description">
          <el-input v-model="dataForm.description" placeholder="人群描述"></el-input>
      </el-form-item>
          <el-form-item label="深度数据合作：可将您的数据数据从 DMP 平台导出，平台将为您进行定制化的挖掘，进行深度数据合作" prop="cooperated">
          <el-input v-model="dataForm.cooperated" placeholder="深度数据合作：可将您的数据数据从 DMP 平台导出，平台将为您进行定制化的挖掘，进行深度数据合作"></el-input>
      </el-form-item>
          <el-form-item label="人群类型，[枚举详情]" prop="type">
          <el-input v-model="dataForm.type" placeholder="人群类型，[枚举详情]"></el-input>
      </el-form-item>
          <el-form-item label="人群来源，[枚举详情]" prop="source">
          <el-input v-model="dataForm.source" placeholder="人群来源，[枚举详情]"></el-input>
      </el-form-item>
          <el-form-item label="处理状态，[枚举详情]" prop="status">
          <el-input v-model="dataForm.status" placeholder="处理状态，[枚举详情]"></el-input>
      </el-form-item>
          <el-form-item label="人群错误码, 1 表示系统错误； 101 表示种子人群活跃用户低于 2K ； 102 表示种子人群无共同特征； 201 表示人群上传的号码包文件格式错误； 202 表示解析人群上传的号码包文件失败； 203 表示号码包文件人群匹配失败。" prop="errorCode">
          <el-input v-model="dataForm.errorCode" placeholder="人群错误码, 1 表示系统错误； 101 表示种子人群活跃用户低于 2K ； 102 表示种子人群无共同特征； 201 表示人群上传的号码包文件格式错误； 202 表示解析人群上传的号码包文件失败； 203 表示号码包文件人群匹配失败。"></el-input>
      </el-form-item>
          <el-form-item label="用户覆盖数" prop="userCount">
          <el-input v-model="dataForm.userCount" placeholder="用户覆盖数"></el-input>
      </el-form-item>
          <el-form-item label="创建时间，格式为 yyyy-MM-dd HH:mm:ss，如 2016-11-01 10:42:56" prop="createdTime">
          <el-input v-model="dataForm.createdTime" placeholder="创建时间，格式为 yyyy-MM-dd HH:mm:ss，如 2016-11-01 10:42:56"></el-input>
      </el-form-item>
          <el-form-item label="最后更新时间，格式为 yyyy-MM-dd HH:mm:ss，如 2016-11-01 10:42:56" prop="lastModifiedTime">
          <el-input v-model="dataForm.lastModifiedTime" placeholder="最后更新时间，格式为 yyyy-MM-dd HH:mm:ss，如 2016-11-01 10:42:56"></el-input>
      </el-form-item>
          <el-form-item label="人群信息，和 type 相关" prop="audienceSpec">
          <el-input v-model="dataForm.audienceSpec" placeholder="人群信息，和 type 相关"></el-input>
      </el-form-item>
          </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        audienceId: '',
        accountId: '',
        name: '',
        externalAudienceId: '',
        description: '',
        cooperated: '',
        type: '',
        source: '',
        status: '',
        errorCode: '',
        userCount: '',
        createdTime: '',
        lastModifiedTime: '',
        audienceSpec: '',
        createDate: '',
        creator: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        audienceId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        accountId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        externalAudienceId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        description: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        cooperated: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        type: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        source: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        errorCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        userCount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createdTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        lastModifiedTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        audienceSpec: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/tencentcustomaudiences/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/tencentcustomaudiences/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
